import Work from "../types/Work";
import { FaReact, FaHtml5, FaCss3Alt  } from "react-icons/fa";
import { SiTypescript, SiJavascript, SiDocker, SiCsharp, SiPython, SiExpress, SiSpring, SiCypress, SiJava, SiAmazonaws, SiMaterialui } from "react-icons/si";
import { DiDjango } from "react-icons/di";


export const TYRO: Work = {
  company: "Tyro Payments",
  role: "Quality Engineer (Automation & Tooling)",
  about: "Tyro Payments is Australia’s largest EFTPOS provider of all ADIs outside the big four1 and we provide tailored EFTPOS, effortless business lending, and banking solutions that support over 61,000 Australian businesses. Beyond credit, debit and EFTPOS card acquiring, we also offer Medicare and private health fund claiming and rebating services.",
  description: "As a Quality Engineer I work for the engineers, By identifiying issues and areas of improvement I create new tools to help speed up the development process by reducing the amount of repetitive work completed by our devs. I primarily work with javascript combined with various different node packages to help create and deliver automation tools and tools to improve efficiency.",
  technologies: [
    {
      tech: 'JavaScript',
      image: <SiJavascript fontSize="32px"/>,
    },
    {
      tech: 'TypeScript',
      image: <SiTypescript fontSize="32px"/>,
    },
    {
      tech: 'React',
      image: <FaReact fontSize="32px"/>,
    },
    {
      tech: 'MaterialUi',
      image: <SiMaterialui fontSize="32px"/>,
    },
    {
      tech: 'Docker',
      image: <SiDocker fontSize="32px"/>,
    },
    {
      tech: 'AWS',
      image: <SiAmazonaws fontSize="32px"/>,
    },
  ],
} 

export const TRIMBLE: Work = {
  company: "Trimble Viewpoint",
  role: "Software Engineering Intern",
  about: "Trimble Viewpoint construction software solutions, part of Trimble Connected Construction, allow contractors to better manage their projects, processes and people, using the data gathered to lower risk and improve margins. Trimble Viewpoint innovations are transforming the construction industry by connecting operations across financial and HR systems, project management tools and mobile field solutions.",
  description: "As a Software Intern I was heavily placed into project work. Completing POC's and presenting demo's on how transitioning and implementing this project to Trimble Viewpoints project will be beneficial in terms of future scalability and code management. Throughout this internship, I explored and experimented with a variety of different technologies, including that of node, react, express, AWS, Tomcat and springboot. Consuming and defining api endpoints to be displayed on a frontend application.",
  technologies: [
    {
      tech: 'JavaScript',
      image: <SiJavascript fontSize="32px"/>,
    },
    {
      tech: 'TypeScript',
      image: <SiTypescript fontSize="32px"/>,
    },
    {
      tech: 'React',
      image: <FaReact fontSize="32px"/>,
    },
    {
      tech: 'MaterialUi',
      image: <SiMaterialui fontSize="32px"/>,
    },
    {
      tech: 'AWS',
      image: <SiAmazonaws fontSize="32px"/>,
    },
    {
      tech: 'Express.js',
      image: <SiExpress fontSize="32px"/>,
    },
    {
      tech: 'SpringBoot',
      image: <SiSpring fontSize="32px"/>,
    },
    {
      tech: 'Java',
      image: <SiJava fontSize="32px"/>,
    },
  ],
}

export const TOSHIBA: Work = {
  company: "Toshiba",
  role: "Software Engineering Intern",
  about: "Toshiba is a world leader and innovator in pioneering high technology, a diversified manufacturer and marketer of advanced electronic and electrical products spanning from information & communications systems, digital consumer products, electronic devices and components, power systems, to industrial and social infrastructure systems and home appliances",
  description: "As an Intern I worked heavily on improving the testing suite of new features for our printer drivers and UI. Working within a .NET techstack I was responsible for delivering high quality code that ensured all edge cases and situations were covered in regards to the flow of Toshiba user interface. I also worked on implementing new feautures in Javascript, adding functionality to the application via plugins.",
  technologies: [
    {
      tech: 'JavaScript',
      image: <SiJavascript fontSize="32px"/>,
    },
    {
      tech: 'Python',
      image: <SiPython fontSize="32px"/>,
    },
    {
      tech: 'C#',
      image: <SiCsharp fontSize="32px"/>,
    },
  ],
}

export const UNSW: Work = {
  company: "UNSW Stimpact Vertically Integrated Project",
  role: "Software Engineer",
  about: "StimPact is a student led project under UNSW's Vertically Integreated Projects program, Where students and lecturers create and develop solutions to solve real world problems. Stimpact aims to address the issue of neuralstimulation, making it more accessible and affordable to researchers whilst still allowing the same functionality (+ more) you would expect from a typical neural stimulator.",
  description: "As a team member of Stimpact I was primarily responsible for the software / firmware side of the project. Creating firmware code using PSOC creator in C and maintaining legacy UI based on kivy (python). Throughout this project the software team had to identify the best and most optimal approach/technologies that would suit the needs of the project and be aligned with the skillset of our team members.",
  technologies: [
    {
      tech: 'JavaScript',
      image: <SiJavascript fontSize="32px"/>,
    },
    {
      tech: 'Python',
      image: <SiPython fontSize="32px"/>,
    },
    {
      tech: 'Cypress',
      image: <SiCypress fontSize="32px"/>,
    },
  ],
} 